import {
	JOB_SIDEBAR_ORDER_FETCHED,
	JOB_SIDEBAR_ORDER_UPDATED,
	LEAD_SIDEBAR_ORDER_FETCHED,
	LEAD_SIDEBAR_ORDER_UPDATED
} from "./actionType";
import {Action} from "redux-actions";
import {OnFailure, OnSuccess, OnSuccessData} from "../actionHelpers";
import {api} from "../../../api/api";
import {Dispatch} from "react-redux";
import {CATEGORY_SORT_ORDER_UPDATED} from "../category/actionType";

/**
 * Job sidebar order fetched successful action.
 * @return {Action<JOB_SIDEBAR_ORDER_FETCHED>}
 * @param order
 */
function jobSidebarOrderFetched(order: Array<string>): Action<JOB_SIDEBAR_ORDER_FETCHED> {
	return {type: JOB_SIDEBAR_ORDER_FETCHED, payload: {order}};
}

/**
 * Update Job sidebar order successful action.
 * @param {Array<string>} order
 * @return {Action<CATEGORY_SORT_ORDER_UPDATED>}
 */
function jobSidebarOrderUpdated(order: Array<string>): Action<JOB_SIDEBAR_ORDER_UPDATED> {
	return {type: JOB_SIDEBAR_ORDER_UPDATED, payload: {order}};
}

/**
 * Lead sidebar order fetched successful action.
 * @return {Action<LEAD_SIDEBAR_ORDER_FETCHED>}
 * @param order
 */
function leadSidebarOrderFetched(order: Array<string>): Action<LEAD_SIDEBAR_ORDER_FETCHED> {
	return {type: LEAD_SIDEBAR_ORDER_FETCHED, payload: {order}};
}

/**
 * Update Lead sidebar order successful action.
 * @param {Array<string>} order
 * @return {Action<LEAD_SIDEBAR_ORDER_UPDATED>}
 */
function leadSidebarOrderUpdated(order: Array<string>): Action<LEAD_SIDEBAR_ORDER_UPDATED> {
	return {type: LEAD_SIDEBAR_ORDER_UPDATED, payload: {order}};
}


/**
 * Fetch job sidebar order from server.
 * @param {OnSuccessData} onSuccess
 * @param {OnFailure} onFailure
 * @return {(dispatch: Dispatch<any>) => void}
 */
export function fetchJobSidebarOrder(onSuccess: OnSuccess, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.sidebarOrderApi.fetchJobSidebarOrder().then(order => {
			dispatch(jobSidebarOrderFetched(order));
			onSuccess();
		}).catch(onFailure);
	};
}

/**
 * Update job sidebar order.
 * @param {string[]} sidebarOrder
 * @param {OnSuccess} onSuccess
 * @param {OnFailure} onFailure
 * @return {(dispatch: Dispatch<any>) => void}
 */
export function updateJobSidebarOrder(sidebarOrder: string[], onSuccess: OnSuccess, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.sidebarOrderApi.updateJobSidebarOrder(sidebarOrder).then(() => {
			dispatch(jobSidebarOrderUpdated(sidebarOrder));
			dispatch(onSuccess);
		}).catch(onFailure);
	};
}

/**
 * Fetch lead sidebar order from server.
 * @param {OnSuccessData} onSuccess
 * @param {OnFailure} onFailure
 * @return {(dispatch: Dispatch<any>) => void}
 */
export function fetchLeadSidebarOrder(onSuccess: OnSuccess, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.sidebarOrderApi.fetchLeadSidebarOrder().then(order => {
			dispatch(leadSidebarOrderFetched(order));
			onSuccess();
		}).catch(onFailure);
	};
}

/**
 * Update lead sidebar order.
 * @param {string[]} sidebarOrder
 * @param {OnSuccess} onSuccess
 * @param {OnFailure} onFailure
 * @return {(dispatch: Dispatch<any>) => void}
 */
export function updateLeadSidebarOrder(sidebarOrder: string[], onSuccess: OnSuccess, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.sidebarOrderApi.updateLeadSidebarOrder(sidebarOrder).then(() => {
			dispatch(leadSidebarOrderUpdated(sidebarOrder));
			dispatch(onSuccess);
		}).catch(onFailure);
	};
}


